// extracted by mini-css-extract-plugin
export default {"appWidth":"800px","Modal":"Modal_Modal__iEfhR"};